import { render, staticRenderFns } from "./SubcontractorDetailsInfo.vue?vue&type=template&id=0f95d9d6&scoped=true"
import script from "./SubcontractorDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SubcontractorDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SubcontractorDetailsInfo.vue?vue&type=style&index=0&id=0f95d9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95d9d6",
  null
  
)

export default component.exports